import React, { useState } from 'react';
import './changeWifiDots.css';
import axiosInstance from '../../../utils/router/axiosInstance';
import { logger } from '../../../utils/logger';

const ModalChangeWifiDots = ({ setIsModalActive, data, selectedBuildingId, onChange }) => {
  const [confirmation, setConfirmation] = useState('');
  const [confirmed, setConfirmed] = useState(false);

  const handleConfirmationChange = (e) => {
    setConfirmation(e.target.value);
    setConfirmed(e.target.value.toLowerCase() === 'изменить');
  };

  const handleChange = async () => {
    if (confirmed) {
      const changePromises = data.map((dots) => axiosInstance.patch(`website/dots/${dots.id}`, dots));

      await Promise.all(changePromises)
        .then(() => {
          onChange();
        })
        .catch((error) => {
          logger.error('Error change some dots WIFI:', error);
        });

      setIsModalActive(false);
    }
  };

  return (
    <div className="UserDelete">
      <p className="DeleteInfo">ВНИМАНИЕ!</p>
      <p className="DeleteInfo">Выбранные точки будут изменены на те данные что вы в них ввели</p>
      <p className="DeleteInfo">Введите слово "Изменить" для подтверждения изменения:</p>
      <input className="DeleteInput" type="text" value={confirmation} onChange={handleConfirmationChange} />
      <button className="DeleteBTN" onClick={handleChange} disabled={!confirmed}>
        Изменить
      </button>
    </div>
  );
};

export default ModalChangeWifiDots;
